import Vue from 'vue';
import {
    Message
} from 'element-ui';
import Router from 'vue-router'

// 路由组件
import error from '@/pages/error'
import mainFrame from '@/pages/mainFrame'
import home from '@/pages/home/index'
import login from '@/pages/login/index'
// 活动管理
import active from '@/pages/active/frame' //外层架子
import activeAuth from '@/pages/active/auth'
import activeAuthDetail from '@/pages/active/authDetail'
import activeInner from '@/pages/active/frameInner' //内层架子
// import activeInnerEmpty from '@/pages/active/innerPage/empty'
import activeInnerIntro from '@/pages/active/innerPage/intro'
import activeInnerBrand from '@/pages/active/innerPage/brand'
import activeInnerBrandInvite from '@/pages/active/innerPage/brandInvite'
// import activeInnerBrandDetail from '@/pages/active/innerPage/brandDetail'
import activeInnerBrandDetail from '@/pages/customer/detail' //品牌商详情改为公用的这个
import activeInnerBuyer from '@/pages/active/innerPage/buyer'
import activeInnerBuyerDetail from '@/pages/active/innerPage/buyerDetail'
import activeInnerBuyerInviteDetail from '@/pages/active/innerPage/buyerInviteDetail'
import activeInnerBuyerOrderDetail from '@/pages/active/innerPage/buyerOrderDetail'
import activeInnerBuyerFriendDetail from '@/pages/active/innerPage/buyerFriendDetail'

import activeInnerOrder from '@/pages/active/innerPage/order'
// import activeInnerOrderDetail from '@/pages/active/innerPage/orderDetail'
import activeInnerOrderDetail from '@/pages/order/detail' //订单详情用这个
import activeInnerProduct from '@/pages/active/innerPage/product'
import activeInnerProductDetail from '@/pages/active/innerPage/productDetail'
import activeInnerProductAdd from '@/pages/active/innerPage/productAdd'
import activeInnerProductAddBatch from '@/pages/active/innerPage/productAddBatch'
import activeInnerProductEdit from '@/pages/active/innerPage/productEdit'



import activeInnerArticle from '@/pages/active/innerPage/article'
// 订单管理
import order from '@/pages/order/frame' //外层架子
import orderIntro from '@/pages/order/intro'
import orderList from '@/pages/order/list'
import orderDetail from '@/pages/order/detail'
// 客户管理
import customer from '@/pages/customer/frame' //外层架子
import customerIntro from '@/pages/customer/intro'
import customerList from '@/pages/customer/list'
import customerDetail from '@/pages/customer/detail' //品牌商详情改为公用的这个
import platUserAuth from '@/pages/customer/platUserAuth'
//系统管理
import system from '@/pages/system/frame' //外层架子
import leftMenuManager from '@/pages/system/leftMenuManager'
import userManager from '@/pages/system/userManager'
import roleManager from '@/pages/system/roleManager'
import functionManager from '@/pages/system/functionManager'
//公共
import editPwd from '@/pages/commonPage/editPwd'

Vue.use(Router)

const router = new Router({
    routes: [{
            path: '/',
            redirect: '/login',
        },
        {
            path: '/login',
            name: 'login',
            component: login,
            meta: {
                title: '登录'
            }
        },
        {
            path: '/mainFrame',
            name: 'mainFrame',
            component: mainFrame,
            children: [{
                    path: '/404',
                    name: 'error',
                    component: error,
                    meta: {
                        title: '404'
                    }
                },
                {
                    path: '/home',
                    name: 'home',
                    component: home,
                    meta: {
                        title: '首页',
                        isShowBread: true,
                        matchLeftKey: '/home'
                    }
                },
                //公共
                {
                    path: '/editPwd',
                    name: 'editPwd',
                    component: editPwd
                },
                {
                    path: '/active',
                    name: 'active',
                    component: active,
                    meta: {
                        title: '活动管理',
                        isShowBread: true
                    },
                    children: [{
                            path: 'auth',
                            name: 'activeAuth',
                            component: activeAuth,
                            meta: {
                                title: '活动审核',
                                isShowBread: true,
                                matchLeftKey: '/active/auth'
                            }
                        },
                        {
                            path: 'activeAuthDetail/:conferenceId',
                            // path: 'activeAuthDetail/:appId/:conferenceId/:invitePartnerId/:inviteUserId',
                            name: 'activeAuthDetail',
                            component: activeAuthDetail,
                            meta: {
                                title: '活动详情',
                                isShowBread: true,
                                isShowBack: true,
                                matchLeftKey: '/active/auth'
                            }
                        },
                        {
                            path: 'activeInner',
                            name: 'activeInner',
                            component: activeInner,
                            meta: {
                                title: '活动列表',
                                matchLeftKey: '/active/activeInner'
                            },
                            children: [
                                // {
                                //     path: 'empty',  //empty
                                //     name: 'activeInnerEmpty',
                                //     component: activeInnerEmpty,
                                //     meta:{title:'活动选择',matchLeftKey:'/active/activeInner'}
                                // },
                                {
                                    path: 'intro/:conferenceId', //第一层
                                    name: 'activeInnerIntro',
                                    component: activeInnerIntro,
                                    meta: {
                                        title: '活动概况',
                                        matchLeftKey: '/active/activeInner'
                                    }
                                },
                                {
                                    path: 'brand/:conferenceId', //第一层
                                    name: 'activeInnerBrand',
                                    component: activeInnerBrand,
                                    meta: {
                                        title: '品牌商管理',
                                        matchLeftKey: '/active/activeInner'
                                    }
                                },
                                {
                                    path: 'brandInvite/:conferenceId', //第一层
                                    name: 'activeInnerBrandInvite',
                                    component: activeInnerBrandInvite,
                                    meta: {
                                        title: '邀请品牌商',
                                        matchLeftKey: '/active/activeInner'
                                    }
                                },
                                {
                                    path: 'brandDetail/:userId',
                                    name: 'activeInnerBrandDetail',
                                    component: activeInnerBrandDetail,
                                    meta: {
                                        title: '品牌商详情',
                                        matchLeftKey: '/active/activeInner'
                                    }
                                },
                                {
                                    path: 'buyer/:conferenceId', //第一层
                                    name: 'activeInnerBuyer',
                                    component: activeInnerBuyer,
                                    meta: {
                                        title: '客户管理',
                                        isShowBack: true,
                                        matchLeftKey: '/active/activeInner'
                                    }
                                },
                                {
                                    path: 'buyerDetail/:userId/:conferenceId',
                                    name: 'activeInnerBuyerDetail',
                                    component: activeInnerBuyerDetail,
                                    meta: {
                                        title: '客户详情',
                                        matchLeftKey: '/active/activeInner'
                                    }
                                },
                                {
                                    path: 'buyerInviteDetail/:conferenceId/:userId/:userName',
                                    name: 'activeInnerBuyerInviteDetail',
                                    component: activeInnerBuyerInviteDetail,
                                    meta: {
                                        title: '客户邀请情况',
                                        matchLeftKey: '/active/activeInner'
                                    }
                                },
                                {
                                    path: 'buyerOrderDetail/:conferenceId/:userId/:userName',
                                    name: 'activeInnerBuyerOrderDetail',
                                    component: activeInnerBuyerOrderDetail,
                                    meta: {
                                        title: '客户下单情况',
                                        matchLeftKey: '/active/activeInner'
                                    }
                                },
                                {
                                    path: 'buyerFriendDetail/:conferenceId/:userId/:userName',
                                    name: 'activeInnerBuyerFriendDetail',
                                    component: activeInnerBuyerFriendDetail,
                                    meta: {
                                        title: '客户邀请的客户下单情况',
                                        matchLeftKey: '/active/activeInner'
                                    }
                                },

                                {
                                    path: 'order/:conferenceId', //第一层
                                    name: 'activeInnerOrder',
                                    component: activeInnerOrder,
                                    meta: {
                                        title: '订单管理',
                                        isShowBack: true,
                                        matchLeftKey: '/active/activeInner'
                                    }
                                },
                                {
                                    path: 'orderDetail/:conferenceId/:orderNumber',
                                    name: 'activeInnerOrderDetail',
                                    component: activeInnerOrderDetail,
                                    meta: {
                                        title: '订单详情',
                                        isShowBack: true,
                                        matchLeftKey: '/active/activeInner'
                                    }
                                },
                                {
                                    path: 'product/:conferenceId', //第一层
                                    name: 'activeInnerProduct',
                                    component: activeInnerProduct,
                                    meta: {
                                        title: '商品管理',
                                        isShowBack: true,
                                        matchLeftKey: '/active/activeInner'
                                    }
                                },
                                {
                                    path: 'productDetail/:conferenceId/:itemUniqueNumber',
                                    name: 'activeInnerProductDetail',
                                    component: activeInnerProductDetail,
                                    meta: {
                                        title: '商品详情',
                                        isShowBack: true,
                                        matchLeftKey: '/active/activeInner'
                                    }
                                },
                                {
                                    path: 'productAdd/:conferenceId',
                                    name: 'activeInnerProductAdd',
                                    component: activeInnerProductAdd,
                                    meta: {
                                        title: '新增商品',
                                        isShowBack: true,
                                        matchLeftKey: '/active/activeInner'
                                    }
                                },
                                {
                                    path: 'productAddBatch/:conferenceId',
                                    name: 'activeInnerProductAddBatch',
                                    component: activeInnerProductAddBatch,
                                    meta: {
                                        title: '批量上传商品',
                                        isShowBack: true,
                                        matchLeftKey: '/active/activeInner'
                                    }
                                },
                                {
                                    path: 'productEdit/:conferenceId/:itemUniqueNumber',
                                    name: 'activeInnerProductEdit',
                                    component: activeInnerProductEdit,
                                    meta: {
                                        title: '商品编辑',
                                        isShowBack: true,
                                        matchLeftKey: '/active/activeInner'
                                    }
                                },
                                {
                                    path: 'article/:conferenceId', //第一层
                                    name: 'activeInnerArticle',
                                    component: activeInnerArticle,
                                    meta: {
                                        title: '页面管理',
                                        isShowBack: true,
                                        matchLeftKey: '/active/activeInner'
                                    }
                                }
                            ]
                        },
                    ]
                },
                {
                    path: '/order',
                    name: 'order',
                    component: order,
                    meta: {
                        title: '订单管理',
                        isShowBread: true
                    },
                    children: [{
                            path: 'intro',
                            name: 'orderIntro',
                            component: orderIntro,
                            meta: {
                                title: '订单概况',
                                isShowBread: true,
                                matchLeftKey: '/order/intro'
                            }
                        },
                        {
                            path: 'list',
                            name: 'orderList',
                            component: orderList,
                            meta: {
                                title: '订单列表',
                                isShowBread: true,
                                matchLeftKey: '/order/list'
                            }
                        },
                        {
                            path: 'detail',
                            name: 'orderDetail',
                            component: orderDetail,
                            meta: {
                                title: '订单详情',
                                isShowBack: true,
                                isShowBread: true,
                                matchLeftKey: '/order/list'
                            }
                        },
                    ]
                },
                {
                    path: '/customer',
                    name: 'customer',
                    component: customer,
                    meta: {
                        title: '客户管理'
                    },
                    children: [{
                            path: 'intro',
                            name: 'customerIntro',
                            component: customerIntro,
                            meta: {
                                title: '客户概况',
                                isShowBread: true,
                                matchLeftKey: '/customer/intro'
                            }
                        },
                        {
                            path: 'list',
                            name: 'customerList',
                            component: customerList,
                            meta: {
                                title: '客户列表',
                                isShowBread: true,
                                matchLeftKey: '/customer/list'
                            }
                        },
                        {
                            path: 'detail/:userId',
                            name: 'customerDetail',
                            component: customerDetail,
                            meta: {
                                title: '客户详情',
                                isShowBack: true,
                                isShowBread: true,
                                matchLeftKey: '/customer/list'
                            }
                        },
                        {
                            path: 'platUserAuth/:appId',
                            name: 'platUserAuth',
                            component: platUserAuth,
                            meta: {
                                title: '系统使用审核',
                                isShowBack: true,
                                isShowBread: true,
                                matchLeftKey: '/customer/list'
                            }
                        },
                    ]
                },
                //系统管理
                {
                    path: '/system',
                    name: 'system',
                    component: system,
                    meta: {
                        title: "系统管理"
                    },
                    children: [{
                            path: 'leftMenuManager',
                            name: 'leftMenuManager',
                            component: leftMenuManager,
                            meta: {
                                title: '菜单管理',
                                isShowBread: true,
                                matchLeftKey: '/system/leftMenuManager'
                            }
                        },
                        {
                            path: 'userManager',
                            name: 'userManager',
                            component: userManager,
                            meta: {
                                title: '用户管理',
                                isShowBread: true,
                                matchLeftKey: '/system/userManager'
                            }
                        },
                        {
                            path: 'roleManager',
                            name: 'roleManager',
                            component: roleManager,
                            meta: {
                                title: '角色管理',
                                isShowBread: true,
                                matchLeftKey: '/system/roleManager'
                            }
                        },
                        {
                            path: 'functionManager',
                            name: 'functionManager',
                            component: functionManager,
                            meta: {
                                title: '功能配置',
                                isShowBread: true,
                                matchLeftKey: '/system/functionManager'
                            }
                        }
                    ]

                }

            ]
        },
        // {
        //     path: '*',
        //     redirect: '/404'
        // },

    ]
})

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}
router.beforeEach((to, from, next) => {
    if(window.gtag){
        gtag('config', 'G-D543LZH1DF', {
            'page_path': to.fullPath
        });
    }
   
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    } else {
        document.title = "多活动发布会管理平台"
    }
    next();
})
router.afterEach((to, from) => {
    function restartLogin() {
        Message({
            message: "请先登录~",
            type: 'warning',
            duration: 500
        });
        setTimeout(function() {
            router.replace("/login")
        }, 500)
    }
    // console.log(to, from)
    let isLogined = getCookie("isLoginedYjjAdminMultiActive")
    if (to.name != 'login' && isLogined != 'y') {
        restartLogin()
    }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js